package br.gov.go.pge.permanenciaweb.site.components

import androidx.compose.runtime.Composable
import br.gov.go.pge.permanenciaweb.site.pages.Tab
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.Text

/*
 * Painel/Eventos/Sem saída tab nav. Silk `Tabs` is not used on purpose: it owns its panels and its
 * row style can't be restyled per instance. The selected tab uses `PrimaryButtonVariant` and
 * `aria-current`, while the URL query string remains the source of truth.
 */

@Composable
internal fun TabNav(selected: Tab, onSelect: (Tab) -> Unit) {
    Row(
        modifier = Modifier
            .gap(0.5.cssRem)
            .padding(top = 0.cssRem, right = 1.5.cssRem, bottom = 0.75.cssRem, left = 1.5.cssRem),
    ) {
        for (tab in Tab.entries) {
            val active = tab == selected
            Button(
                onClick = { onSelect(tab) },
                variant = if (active) PrimaryButtonVariant else DefaultButtonVariant,
                size = ButtonSize.SM,
                modifier = if (active) {
                    Modifier.attrsModifier { attr("aria-current", "page") }
                } else {
                    Modifier
                },
            ) {
                Text(tab.navLabel)
            }
        }
    }
}
